import { createModifiedOnColDef } from '../../components/shared-columns/modified-on/modified-on';
import type { InvestorFirmFragment } from '../graphql/__generated__';
import { addressColDef } from './address';
import { cikColDef } from './cik';
import { crdColDef } from './crd';
import { descriptionColDef } from './description';
import { emailColDef } from './email';
import { factSetColDef } from './factSet';
import { faxColDef } from './fax';
import { firmKey } from './firm-key';
import { firmNameColDef } from './firm-name';
import { firmSubTypeColDef } from './firm-subtype';
import { firmTypeColDef } from './firm-type';
import { investorContactsColDef } from './investor-contacts';
import { leiColDef } from './lei';
import { cmgEntityKeyColDef } from './linked-cmg-entity-key';
import { cmgEntityNameColDef } from './linked-cmg-entity-name';
import { linkedStatusColDef } from './linked-status';
import { isOnPlatformColDef } from './on-platform';
import { phoneColDef } from './phone';
import { salesCoverageColDef } from './sales-coverage';
import { statusColDef } from './status';
import { updatedByColDef } from './updated-by';
import { websiteColDef } from './website';

export const investorFirmsColumnDefs = [
  firmNameColDef,
  firmKey,
  statusColDef,
  firmTypeColDef,
  firmSubTypeColDef,
  websiteColDef,
  addressColDef,
  emailColDef,
  phoneColDef,
  faxColDef,
  cikColDef,
  crdColDef,
  leiColDef,
  factSetColDef,
  descriptionColDef,
  salesCoverageColDef,
  investorContactsColDef,
  linkedStatusColDef,
  cmgEntityKeyColDef,
  cmgEntityNameColDef,
  isOnPlatformColDef,
  createModifiedOnColDef<InvestorFirmFragment>('modifiedOn'),
  updatedByColDef,
];
